<template>
    <div>
        <div class="col-12" v-if="ticketLoader">
            <div class="loader"></div>
        </div>
        <form @submit.prevent="createTicket" v-else>
            <div class="form-group">
                <label for="emailSub">Subject <strong class="text-danger">*</strong></label>
                <input type="text" class="form-control" id="emailSub" aria-describedby="emailSub" required v-model.trim="subject">
            </div>
            <div class="form-group">
                <label for="domainSub">Select Domain <strong class="text-danger">*</strong></label>
                <select  class="form-control" id="domainSub" aria-describedby="domainSub" required v-model="selectedDomain">
                    <template v-for="(domain, index) in supervisor.allowedDomains" >
                        <option :value="domain" :key="domain + '_' + index">{{domain}}</option>
                    </template>
                </select>
            </div>
            <div class="form-check" style="margin-top: 20px;margin-bottom: 10px">
                <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="isCC" />
                    Do you also want to receive this ticket in your email ({{ user.email }})?
                    <span class="form-check-sign"></span>
                </label>
            </div>
            <div class="form-group">
                <label for="ticketBody">Message <strong class="text-danger">*</strong></label>
                <textarea class="form-control" id="ticketBody" rows="7" v-model.trim="message"></textarea>
            </div>
            <button type="submit" class="btn btn-primary btn-lg w-100"><i class="fa fa-paper-plane" aria-hidden="true"></i> Submit Ticket</button>
        </form>
    </div>

</template>

<script>
    import { functions } from "@/firebase/init"
    import swal from 'sweetalert2';
    export default {
        name: "OpenNewTicket",
        data() {
            return {
                subject: '',
                message: '',
                selectedDomain: '',
                ticketLoader: false,
                isCC: true
            }
        },
        props: ['supervisor'],
        computed: {
            clientID() {
                return this.$store.getters.getRequestCustomerID;
            },
            user() {
                return this.$store.getters.user;
            }
        },
        methods: {
            createTicket () {
                if(this.subject === '' || this.message === '' || this.selectedDomain === '') {
                    swal({
                        title: "All fields required!",
                        text: "Please fill all the fields as all fields are required.",
                        type: "error",
                        confirmButtonText: "Try Again",
                        confirmButtonColor: "#EE8057"
                    })
                } else {
                    this.ticketLoader = true;

                    const openNewTicket = functions.httpsCallable("openNewTicket");
                    openNewTicket({
                        clientID: this.clientID,
                        subject: 'WPO : ' + this.subject + ' :: ' + this.selectedDomain,
                        message: this.message,
                        cc: (this.isCC) ? this.user.email : '',
                        submitterName: this.user.firstName + ' ' + this.user.lastName
                    })
                        .then(response => {
                            this.ticketLoader = false;

                            if(response.data.success) {
                                swal({
                                    title: "Ticket Created Successfully!",
                                    text: response.data.message,
                                    type: "success",
                                    confirmButtonText: "OK!",
                                    confirmButtonColor: "#6ACF98"
                                });
                            } else {
                                swal({
                                    title: "Something went Wrong!",
                                    text: response.data.message,
                                    type: "error",
                                    confirmButtonText: "Try Again",
                                    confirmButtonColor: "#EE8057"
                                })
                            }
                        })
                        .catch(err => {
                            this.ticketLoader = false;
                            swal({
                                title: "Something went Wrong!",
                                text: err.message,
                                type: "error",
                                confirmButtonText: "Try Again",
                                confirmButtonColor: "#EE8057"
                            });
                            this.addLog({
                                message: "Error: Open Ticket, Message:" + err.message,
                                level:  "danger"
                            })
                        }).finally(() => {
                            this.subject = '';
                            this.message = '';
                            this.selectedDomain = '';
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>
